import utils from 'Utils';
import {
  actionRequestData,
  actionReceiveData,
  actionReceiveDataError,
  actionDisplayLoadingWarning,
} from 'Actions';
import config from 'Config/appConfig';

const { parseJSON, checkStatus } = utils.http;
const localHosts = [
  'localhost',
  'kaiser-family-foundation.alley.test',
];

export function apiUrl(win = window) {
  if (-1 < localHosts.indexOf(win.location.hostname)) {
    return config.apiUrl.local;
  }
  if ('kff-org-preprod.go-vip.co' === win.location.hostname ||
    'kff-org-develop.go-vip.co' === win.location.hostname
  ) {
    return config.apiUrl.staging;
  }
  if ('www.kff.org' === win.location.hostname) {
    return config.apiUrl.production;
  }
  return config.apiUrl.production;
}

/**
 * Fetch data from the api
 * @param  {array} indicators settings for indicator { key, year }
 * @param  {array} states     states to retreive
 * @return {function}         action dispatch function
 */
export default function fetchReport({ indicators, states }) {
  return (dispatch) => {
    // update state to inform of fetch
    dispatch(actionRequestData());

    // See if the user wants to bust the cache on thse indicators
    const noCache = -1 < window.location.search.indexOf('preview=1');
    // We are filtering out duplicate indicators here.
    const filteredIndicators = indicators
      .filter((item, idx, arr) => arr
        .findIndex((curr) => curr.key === item.key) === idx);
    const timeout =
      setTimeout(() => dispatch(actionDisplayLoadingWarning()), 10000);
    return fetch(`${apiUrl()}/report`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        indicators: filteredIndicators,
        states: states.map((state) =>
          ('Dist. of Columbia' === state ? 'District of Columbia' : state)
        ),
        noCache,
      }),
    })
    .then(checkStatus)
    .then(parseJSON)
    .then((json) => dispatch(actionReceiveData(json)))
    .then(() => clearTimeout(timeout))
    // Catch for checkStatus
    .catch((error) => dispatch(actionReceiveDataError(error)));
  };
}



// WEBPACK FOOTER //
// ./app/services/fetchReport.js